import { useEffect } from 'react';

export default function useClearSearchParams(searchParams: string[]): void {
  useEffect(() => {
    const url = new URL(window.location.href);
    searchParams.forEach((param) => url.searchParams.delete(param));
    window.history.replaceState({}, '', url);
  }, [searchParams]);
}
